export const ORDER_STATUS_ORDERED = 'ORDERED';

export const ORDER_STATUS_COMPLETED = 'COMPLETED';
